import React from 'react';
import { Prompt } from 'react-router-dom';
import { withFormik, Form } from 'formik';
import styled from 'styled-components';
import * as yup from 'yup';
import Button from '../../../../components/atomic/Buttons/Button';
import TextInput from '../../../../components/molecule/FormFields/TextInput';
import * as apiServices from '../../../../services/apiServices';
import { toast } from 'react-toastify';
import InputAdornment from '@material-ui/core/InputAdornment';

const Container = styled.div`
  display: flex;
  justify-content: center;
`
const StretchContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
`
const TextInputStyled = styled(TextInput)`
  border: 1px solid #ccc;
  background: #eee;
  padding: 10px;
  margin-bottom: 6px;
  border-radius: 10px;
`

const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  // background: rgba(0,0,0,0.1);
  margin: 3px;
  margin-bottom: auto;
`
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 10px;
`
const ButtonStyled = styled(Button)`
  margin-left: 8px;
`
const FormStyled = styled(Form)`
  display: flex;
  flex-direction: column;
`

class ChannelNameForm extends React.Component {
  changeTracker = (value, name) => this.props.setFieldValue(name, value, true);

  onAcceptVideo = async (files) => {
    const promises = files.map(file => {
      return apiServices.uploadOverviewVideo(file, { 
        headers: {
          'Content-Disposition': `attachment; filename=${file.name}`
        } 
      })
    })
    Promise.all(promises)
    .then(results => {
      toast.success('videos uploaded successfully');
      let newVideo = null;
      results.map(result => newVideo = {id: result.id, video: result.video});
      this.changeTracker(newVideo,'video')
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(e.message);
    })
  }

  onRejectVideo = (files) => {
    console.log('component: ',this,'video(s) rejected:', files[0]);
    toast.error('video(s) rejected');
  }

  onAcceptImage = async (files) => {
    const promises = files.map(file => {
      return apiServices.uploadImages(file, { 
        headers: {
          'Content-Disposition': `attachment; filename=${file.name}`
        } 
      })
    })
    Promise.all(promises)
    .then(results => {
      toast.success('image uploaded successfully');
      let newImage = null;
      results.map(result => newImage = {id: result.id, url: result.url});
      this.changeTracker(newImage,'image')
    })
    .catch(e => {
      console.log('component: ',this,e);
      toast.error(e.message);
    })
  }

  onRejectImage = (files) => {
    console.log('component: ',this,'video(s) rejected:', files[0]);
    toast.error('image rejected');
  }
  
  manualSubmit = () => {
    const { submitExerciseForm } = this.props;
    submitExerciseForm();
  }

  render () {
    const {
      values,
      onClickCancel,
      dirty,
    } = this.props
    return (
      <FormStyled>
        <Container>
          <StretchContainer>
            <InfoContainer>
              <TextInputStyled
                type="text"
                label="Channel Name"
                fullWidth
                multiline={false}
                onChange={val => this.changeTracker(val,'channel_name')}
                value={values.channel_name}
                InputProps={{
                  startAdornment: <InputAdornment position="start">@</InputAdornment>,
                }}
              />
            </InfoContainer>
          </StretchContainer>
        </Container>
        <ButtonContainer>
          <ButtonStyled disabled={!dirty} type="submit" color="primary" variant="contained">Save</ButtonStyled>
          <ButtonStyled onClick={onClickCancel} color="secondary" variant="contained">Cancel</ButtonStyled>
        </ButtonContainer>
        <Prompt when={dirty} message={`You have unsaved changes. Are you sure you want to leave?`}/>
      </FormStyled>
    );
  }
};

export default withFormik({
  mapPropsToValues: props => Object.assign(props.initialValues),

  validationSchema: yup.object().shape({
    channel_name: yup.string(),
  }),

  handleSubmit: (values, { props, setSubmitting }) => {
    props.submit(values);
    setSubmitting(false);
  },

  displayName: 'BasicForm',
})(ChannelNameForm);
